import React from 'react';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';
import { Phone, Mail, MapPin, Clock, MessageCircle } from 'lucide-react';
import { companyInfo } from '../mock';

const Contact = () => {
  const handleCall = () => {
    window.location.href = `tel:${companyInfo.phone}`;
  };

  const handleWhatsApp = () => {
    const phoneNumber = '491522757500';
    const message = encodeURIComponent('Hallo, ich interessiere mich für Ihre Hausmeister-Dienstleistungen.');
    window.open(`https://wa.me/${phoneNumber}?text=${message}`, '_blank');
  };

  return (
    <section id="contact" className="py-24 bg-slate-50">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6">
              Kontaktieren Sie uns
            </h2>
            <p className="text-xl text-slate-600 max-w-2xl mx-auto">
              Rufen Sie uns direkt an oder schreiben Sie uns per WhatsApp – wir sind für Sie da!
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            {/* Direct Contact Card */}
            <Card className="border-slate-200 shadow-xl">
              <CardContent className="p-8">
                <h3 className="text-2xl font-bold text-slate-900 mb-6">
                  Direkter Kontakt
                </h3>
                <div className="space-y-6">
                  <div className="flex items-start space-x-4">
                    <div className="bg-slate-900 rounded-lg p-3 flex-shrink-0">
                      <Phone className="w-6 h-6 text-white" />
                    </div>
                    <div className="flex-1">
                      <div className="font-semibold text-slate-900 mb-1">Telefon</div>
                      <a
                        href={`tel:${companyInfo.phone}`}
                        className="text-lg text-slate-700 hover:text-slate-900 transition-colors"
                      >
                        {companyInfo.phone}
                      </a>
                    </div>
                  </div>

                  <div className="flex items-start space-x-4">
                    <div className="bg-slate-900 rounded-lg p-3 flex-shrink-0">
                      <Mail className="w-6 h-6 text-white" />
                    </div>
                    <div className="flex-1">
                      <div className="font-semibold text-slate-900 mb-1">E-Mail</div>
                      <a
                        href={`mailto:${companyInfo.email}`}
                        className="text-lg text-slate-700 hover:text-slate-900 transition-colors"
                      >
                        {companyInfo.email}
                      </a>
                    </div>
                  </div>

                  <div className="flex items-start space-x-4">
                    <div className="bg-slate-900 rounded-lg p-3 flex-shrink-0">
                      <MapPin className="w-6 h-6 text-white" />
                    </div>
                    <div className="flex-1">
                      <div className="font-semibold text-slate-900 mb-1">Adresse</div>
                      <div className="text-slate-700">
                        {companyInfo.address}<br />
                        {companyInfo.city}
                      </div>
                    </div>
                  </div>

                  <div className="flex items-start space-x-4">
                    <div className="bg-slate-900 rounded-lg p-3 flex-shrink-0">
                      <Clock className="w-6 h-6 text-white" />
                    </div>
                    <div className="flex-1">
                      <div className="font-semibold text-slate-900 mb-1">Öffnungszeiten</div>
                      <div className="text-slate-700 whitespace-pre-line">
                        {companyInfo.workingHours}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="mt-8 pt-8 border-t border-slate-200 space-y-3">
                  <Button
                    onClick={handleCall}
                    className="w-full bg-slate-900 hover:bg-slate-800 text-white"
                    size="lg"
                  >
                    <Phone className="w-5 h-5 mr-2" />
                    Jetzt anrufen
                  </Button>
                  <Button
                    onClick={handleWhatsApp}
                    className="w-full bg-green-600 hover:bg-green-700 text-white"
                    size="lg"
                  >
                    <MessageCircle className="w-5 h-5 mr-2" />
                    WhatsApp schreiben
                  </Button>
                </div>
              </CardContent>
            </Card>

            {/* Google Maps */}
            <Card className="border-slate-200 shadow-xl overflow-hidden">
              <div className="w-full h-full min-h-[500px]">
                <iframe
                  title="Stark Hausmeisterservice Location"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2654.8!2d10.4916!3d48.5803!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDjCsDM0JzQ5LjEiTiAxMMKwMjknMjkuOCJF!5e0!3m2!1sen!2sde!4v1234567890"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                ></iframe>
              </div>
            </Card>
          </div>

          <div className="text-center mt-12">
            <p className="text-lg text-slate-600">
              💪 Schnelle Terminvergabe • ⭐ Zuverlässiger Service • 📞 24/7 Notfallservice
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
